export function calcDivideBy(num, divisor = 1) {
  if (typeof num !== "number") return 0;
  return Math.floor(num / divisor)
}